// import { AVAILABLE_PACKAGES } from "../../product/packageList";
import { Service2026Details } from "../../../types/servicePackageType";

export type PremiumMemberShipPackage<T extends string> = Omit<
  Service2026Details,
  "type"
> & {
  type: T;
  주의사항: string;
  packageKey: string;
};

export const 일반장프리미엄2026: PremiumMemberShipPackage<"일반장 프리미엄"> = {
  type: "일반장 프리미엄",
  packageKey: "",
  summary: `좋은 용품과 조문객 걱정없는 장례`,
  backgroundColor: "#29353F",
  mainColor: "#69A5FF",
  subColor: "#F8FAFD",
  description: `고급 용품으로 업그레이드된 일반장 서비스로 할인가를 보장받으실 수 있어요.`,
  recommendationText: `<b>고이 일반장은,</b>
  200명 내외의 조문객과 함께, 
  조문객 맞이에 불편함이 없는 
  장례를 희망하는 분께 추천드립니다.`,
  imageSrc: "platform/service/service_normal_premium.png",
  주의사항: `30만원 납입시 추가 10% 할인
  <br />서비스 이용 당해 년도 프리미엄 패키지 10%할인 적용
  <br />(가입비 30만원 + 패키지 401만 1천원(2025년내 이용 예시))`,
  정상가: 599,
  가격: 479,
  최종할인가: 431,
  조문객: "200명 내외",
  빈소: "60평 이상",
  접객도우미: "6명",
  "장례 용품": "고급형",
  "장의 차량": 2,
  details: [
    {
      key: "용품",
      contents: [
        {
          src: "platform/service/gwan0-2025.png",
          title: "0.6 오동관",
          descriptions: `화장용`,
          price: 200_000,
        },
        {
          src: "platform/service/sui2-2025.png",
          title: "고급 대마 가진수의",
          descriptions: `(대마 100%)`,
          price: 1_500_000,
          discountPrice: 500_000,
        },
        {
          src: "platform/service/ugol5.png",
          title: "이중 진공 유골함",
          descriptions: ``,
          price: 720_000,
          discountPrice: 520_000,
        },
        {
          src: "platform/service/6.png",
          title: "관 장식용 생화",
          descriptions: "고급 생화, 국화꽃",
          price: 200_000,
        },
        {
          src: "platform/service/5.png",
          title: "입관 수시 용품",
          descriptions: "20종(멧베 등)",
          price: 280_000,
        },
        {
          src: "platform/service/7.png",
          title: "빈소 용품",
          descriptions: "위패, 향, 부의록 등",
          price: 50_000,
        },
        {
          src: "platform/service/funeral_flowers_202601.png",
          title: "헌화 꽃",
          descriptions: "30송이",
          price: 50_000,
        },
        {
          src: "platform/service/sangbok_male_202602.png",
          title: "남자 상복",
          descriptions: "6벌",
          price: 300_000,
        },
        {
          src: "platform/service/sangbok_female_202602.png",
          title: "여자 상복",
          descriptions: "6벌",
          price: 120_000,
        },
        {
          src: "platform/service/sangbok.png",
          title: "상주 용품",
          descriptions: "완장, 리본 등",
          price: 0,
        },
        {
          src: "platform/service/disposable1.png",
          title: "조문객 일회용품",
          descriptions: "200인분",
          discountPrice: 100_000,
          price: 200_000,
        },
      ],
    },
    {
      key: "인력",
      contents: [
        {
          src: "platform/service/person1.png",
          title: "장례지도사",
          descriptions: "1인 3일",
          price: 600_000,
        },
        {
          src: "platform/service/person2.png",
          title: "염습상례사",
          descriptions: "1인 1일",
          price: 150_000,
        },
        {
          src: "platform/service/person3.png",
          title: "접객 도우미",
          descriptions: "6인 10시간",
          price: 720_000,
        },
      ],
    },

    {
      key: "차량",
      contents: [
        {
          src: "platform/service/ambulance.png",
          title: "고인이송차량",
          descriptions: `관내 이송`,
          price: 100_000,
        },
        {
          src: "platform/service/bus.png",
          title: "45인승 장의버스",
          descriptions: `200km 왕복`,
          price: 450_000,
        },
        {
          src: "platform/service/limousine.png",
          title: "리무진",
          descriptions: `200km 화장장 편도`,
          price: 450_000,
        },
      ],
    },
  ],
  extraDetails: [
    {
      key: "희망하시는 경우 용품을 변경할 수 있습니다",
      contents: {
        유골함: [
          {
            src: "platform/service/ugol3.png",
            title: "종교별 유골함",
            descriptions: "상세 품목 요청시 카탈로그 제공",
            price: 500_000,
            discountPrice: 450_000,
          },
        ],
        매장용품: [
          {
            src: "platform/service/gwan1-2025.png",
            title: "매장용 관, 용품, 인력",
            descriptions: `오동나무 1.0관으로 변경(+10)
          횡대, 결관포 등 용품 추가(+12)
          유골함 공제(-52)
          `,
            price: -300_000,
          },
        ],
      },
      // [
      //   {
      //     src: "platform/service/ugol3.png",
      //     title: "종교별 유골함",
      //     descriptions: "상세 품목 요청시 카탈로그 제공",
      //     price: 500_000,
      //     discountPrice: 450_000,
      //   },
      //   {
      //     src: "platform/service/gwan1-2025.png",
      //     title: "매장용 관, 용품, 인력",
      //     descriptions: `오동나무 1.0관으로 변경(+10)
      //     횡대, 결관포 등 용품 추가(+12)
      //     유골함 공제(-52)
      //     `,
      //     price: -300_000,
      //   },
      // ],
    },
  ],
  steps: [
    [
      {
        src: "images/service/first_1.png",
        title: "고인 이송",
        description: "임종 후, 병원이나 장례식장으로 이송합니다.",
      },
      {
        src: "images/service/first_2.png",
        title: "고인 안치",
        description:
          "고인의 옷과 몸을 바르게 하는 수시 후, 고인을 장례식장에 안치합니다.",
      },
      {
        src: "images/service/first_3.png",
        title: "빈소 설치",
        description: "조문객의 인원과, 가족수에 맞는 빈소를 설치합니다.",
      },
      {
        src: "images/service/first_4.png",
        title: "화장장 예약",
        description:
          "3일차에 화장이 가능하도록 장례지도사님께서 미리 화장장 예약을 진행합니다.",
      },
      {
        src: "images/service/first_5.png",
        title: "부고 문자 발송",
        description:
          "꼭 필요한 정보가 누락되지 않도록 부고문자를 작성해드립니다.",
      },
    ],
    [
      {
        src: "images/service/second_1.png",
        title: "염습",
        description:
          "고인의 몸을 깨끗이 한 후, 수의를 입힙니다. 입관전에 거치는 절차입니다.",
      },
      {
        src: "images/service/second_2.png",
        title: "입관식",
        description:
          "염습 후 고인의 마지막 모습을 보면서 애도할 수 있는 입관식을 진행합니다.\n" +
          "(고인의 종교에 따라 종교지도사 참여 가능합니다.)",
      },
      {
        src: "images/service/second_3.png",
        title: "성복",
        description:
          "정식으로 상복을 입는 절차입니다. 요즘에는 1일차에 바로 상복을 입지만, 입관 후 정식으로 완장/머리핀을 착용하게 됩니다.",
      },
      {
        src: "images/service/second_4.png",
        title: "성복제",
        description:
          "성복 후 고인께 제례를 드리는 절차로 종교에 따라 생략 혹은 대체가 가능합니다.",
      },
      {
        src: "images/service/second_5.png",
        title: "조문",
        description:
          "일반적으로 2일차에 조문객이 가장 많이 옵니다. 상황에 맞게 인력을 배치해드립니다.",
      },
    ],
    [
      {
        src: "images/service/third_1.png",
        title: "발인",
        description:
          "관이 장례식장을 떠나는 절차이며, 관을 버스나 리무진까지 옮깁니다.",
      },
      {
        src: "images/service/third_2.png",
        title: "운구",
        description:
          "고인을 장지까지 옮기는 절차이며, 버스나 리무진으로 이송합니다.",
      },
      {
        src: "images/service/third_3.png",
        title: "화장 / 유골 안치",
        description: "예약한 시간에 화장 후 안치시설로 옮깁니다.",
      },
      {
        src: "images/service/third_4.png",
        title: "사후 행정",
        description:
          "사망신고, 유족연금, 상속신고 등 법적, 행정적 안내를 도와드립니다.",
      },
    ],
  ],
  deductions: [
    "4일장, 5일장 등 3일장에서 일정이 길어질 경우 장례지도사 서비스 비용이 1일 당 20만원씩 추가됩니다. (무빈소장 15만 원)",
    "접객도우미는 시간 초과 시 시간당 2만 원이 추가되며, 반대로 시간 당 공제는 불가능합니다.",
  ],
  extra: [
    "고인이송차량은 관외 이용 시 추가 비용이 발생하며, 금액은 거리와 상황에 따라 책정됩니다.",
    "정해진 거리(200km)를 초과하여 장의차량을 이용할 경우, 차량 서비스 비용이 1km 당 2천원씩 추가됩니다.",
    "리무진은 편도 이용 기준이며, 초과거리당 1km 당 2천원이 추가됩니다.",
    "장지 이외의 장소에 경유를 요청하는 경우, 이동 거리 및 소요 시간에 따라 별도로 추가 경유비가 발생합니다.",
    "유골함에 각인 서비스를 요청하실 경우 각인비가 최대 2만 원이 발생합니다.",
    "출동 후 서비스 이용을 취소하실 경우 취소 위약금이 기본 25만 원이 발생하며, 고인이송차량, 접객도우미 등 이미 준비가 완료된 품목들에 대해 추가로 비용이 청구됩니다.",
    "장례 진행 중 차량 배차, 접객 도우미 배치 등 이미 준비가 완료된 사항에 대해 취소 요청할 시 공제가 불가능합니다.",
    "사고사 등 특수염이 필요할 경우, 최대 50만 원의 추가금이 발생합니다.",
  ],
};
